<cx-icon type="LOADER"></cx-icon>
